import { EnumWorkersTypes } from "./WorkersTypes.enums";



/** All report types and it's labels */
export const EnumTypeReports: Record<keyof typeof EnumWorkersTypes, string> = {
	operators: 'Operador',
	suppliers: 'Fornecedor',
	staff: 'Staff',
} as const;
